import Vue from 'vue/dist/vue.esm';
import axios from 'common/axios';
import SetAndCreateForm from 'components/my_lists/set_and_create_form.vue';
import AddedMyLists from 'components/my_lists/added_my_lists.vue';
import VueTextareaAutosize from 'vue-textarea-autosize';

document.addEventListener('DOMContentLoaded', () => {
  const currentUserId = JSON.parse(document.getElementById('my_list-new').dataset.currentUserId);
  const listableData = JSON.parse(document.getElementById('my_list-new').dataset.listableData);

  Vue.use(VueTextareaAutosize);

  new Vue({
    el: '#my_list-new',
    components: { SetAndCreateForm, AddedMyLists },
    data: {
      myLists: [],
      addedMyLists: [],
      addedMyListsSize: 0,
      visibleForm: false,
      visibleNewMyListForm: false
    },
    computed: {
      currentUserId: function () {
        return currentUserId;
      },
      myListType: function () {
        return listableData.my_list_type;
      },
      listableId: function () {
        return listableData.listable_id;
      },
      listableType: function () {
        return listableData.listable_type;
      },
      targetAddedMyListPath: function() {
        return '/mypage/my_lists/target_added';
      }
    },
    mounted: function() {
      let $showLink = document.getElementById('my_list-new--link');
      $showLink.addEventListener('click', this.showForm);
      this.loadAddedMyLists();
    },
    methods: {
      loadAddedMyLists: async function() {
        await axios.get(this.targetAddedMyListPath, {
          params: {
            listable_id: this.listableId,
            listable_type: this.listableType
          }
        }).then(({ data }) => {
          this.addedMyLists = data.added_my_lists;
          this.addedMyListsSize = data.size;
        });
        this.onLoadAddedMyLists();
      },
      showForm: function() {
        this.visibleForm = true;
      },
      showNewMyListForm: function() {
        this.visibleNewMyListForm = true;
      },
      hideAllForm: function() {
        this.visibleForm = false;
        this.visibleNewMyListForm = false;
      },
      setMyLists: function(newMyLists) {
        this.myLists = newMyLists;
      },
      onLoadAddedMyLists: function() {
        this.addedMyListsSize == 0 ? this.changeMyListAddedMark(false) : this.changeMyListAddedMark(true);
      },
      changeMyListAddedMark: function(added) {
        document.getElementById('my_list-new--link').dataset.listed = added;
      }
    },
    template: `
      <div class="mylist--editor">
        <added-my-lists
          :myLists='addedMyLists'
          :size='addedMyListsSize'
        >
        </added-my-lists>
        <set-and-create-form
          :myListsFromParent='myLists'
          :currentUserId='currentUserId'
          :myListType='myListType'
          :listableId='listableId'
          :listableType='listableType'
          :visibleForm='visibleForm'
          :visibleNewMyListForm='visibleNewMyListForm'
          @show-new-my-list-form='showNewMyListForm'
          @hide-all-form='hideAllForm'
          @set-my-lists='setMyLists'
          @load-added-my-lists='loadAddedMyLists'
        >
        </set-and-create-form>
      </div>
    `
  });
});
